// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  overflow: hidden;
}

.main {
  height: 100%;
  overflow-y: auto;
  padding: 30px 22px 0px;
}

.item-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.item-list .item_wrapper {
  margin-bottom: 8px;
}
.item-list .item_wrapper:last-child {
  margin-bottom: 0;
}

.separator {
  background: url('separator.svg') center center no-repeat;
  background-size: cover;
  height: 6px;
  margin: 5px 0;
}

.total_wrapper .sanifair_sum_block {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total_wrapper .sanifair_sum_block .text {
  font-size: 12px;
  text-transform: capitalize;
}
.total_wrapper .sanifair_sum_block .sum {
  font-family: AppFont;
  font-size: 12px;
  font-weight: 700;
}
.total_wrapper .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
}
.total_wrapper .total .text,
.total_wrapper .total .sum {
  color: #2f333a;
  font-family: AppFontBold;
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
}

ion-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-footer .button_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0px 22px 27px;
}
ion-footer .button_wrapper ion-button {
  text-align: center;
  font-size: 16px;
  font-family: Tusker, sans-serif;
  text-transform: uppercase;
  width: 100%;
}
ion-footer .button_wrapper .top_button {
  color: #fff;
  margin-bottom: 8px;
}
ion-footer .button_wrapper .forward_button {
  --background: transparent;
  border-radius: 50px;
  border: 3px solid var(--ion-color-tertiary);
  color: var(--ion-color-tertiary);
}

.bold_title {
  font-weight: 100 !important;
  font-family: Tusker, sans-serif !important;
  text-transform: capitalize;
  color: var(--ion-color-primary) !important;
}

.border-line {
  width: 100%;
  fill: var(--ion-color-primary) !important;
}

ion-header ion-toolbar {
  --background: var(--ion-color-secondary);
}
ion-header ion-toolbar .header_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sanifair-list/sanifair-list.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAEI;EACE,gBAAA;AAAN;;AAKA;EACE,wDAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAFF;;AAME;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAHJ;AAKI;EACE,eAAA;EACA,0BAAA;AAHN;AAKI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAOI;;EAEE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AALN;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPF;AAQE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AANJ;AAQI;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,yBAAA;EACA,WAAA;AANN;AAUI;EACE,WAAA;EACA,kBAAA;AARN;AAWI;EACE,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gCAAA;AATN;;AAaA;EACE,2BAAA;EACA,0CAAA;EACA,0BAAA;EACA,0CAAA;AAVF;;AAYA;EACE,WAAA;EACA,yCAAA;AATF;;AAaE;EACE,wCAAA;AAVJ;AAYI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAVN","sourcesContent":["$horizontal_padding: 22px;\n\nion-content {\n  overflow: hidden;\n}\n\n.main {\n  height: 100%;\n  overflow-y: auto;\n  padding: 30px $horizontal_padding 0px;\n}\n\n.item-list {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n\n  .item_wrapper {\n    margin-bottom: 8px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.separator {\n  background: url(../../../assets/tabilo/separator.svg) center center no-repeat;\n  background-size: cover;\n  height: 6px;\n  margin: 5px 0;\n}\n\n.total_wrapper {\n  .sanifair_sum_block {\n    height: 40px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .text {\n      font-size: 12px;\n      text-transform: capitalize;\n    }\n    .sum {\n      font-family: AppFont;\n      font-size: 12px;\n      font-weight: 700;\n    }\n  }\n\n  .total {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 40px;\n\n    .text,\n    .sum {\n      color: #2f333a;\n      font-family: AppFontBold;\n      font-size: 16px;\n      font-weight: 900;\n      text-transform: uppercase;\n    }\n  }\n}\n\nion-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .button_wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 0px $horizontal_padding 27px;\n\n    ion-button {\n      text-align: center;\n      font-size: 16px;\n      font-family: Tusker, sans-serif;\n      text-transform: uppercase;\n      width: 100%;\n\n    }\n\n    .top_button {\n      color: #fff;\n      margin-bottom: 8px;\n    }\n\n    .forward_button {\n      --background: transparent;\n      border-radius: 50px;\n      border: 3px solid var(--ion-color-tertiary);\n      color: var(--ion-color-tertiary);\n    }\n  }\n}\n.bold_title {\n  font-weight: 100 !important;\n  font-family: Tusker, sans-serif !important;\n  text-transform: capitalize;\n  color: var(--ion-color-primary) !important;\n}\n.border-line {\n  width: 100%;\n  fill: var(--ion-color-primary) !important;\n}\nion-header {\n\n  ion-toolbar{\n    --background: var(--ion-color-secondary);\n\n    .header_block {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 0px 10px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
